import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { LinkProps, useLocation } from 'react-router-dom';

import { TrophyIcon } from '@/assets/icon/components/Trophy.icon';

import { useLocalStorage } from '@/hooks/useLocalStorage.hook';
import useMediaQuery from '@/hooks/useMediaQuery.hook';

import { MediaQueriesEnum } from '@/enums/mediaQueries.enum';
import { RoutesEnum } from '@/enums/routes.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { tKeys } from '@/i18n/resourses';

interface IHeaderNavigation {
  label: string;
  icon?: React.ReactNode;
  selected: boolean;
  linkData: LinkProps;
}
export const useNavLinks = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isMobile] = useMediaQuery(MediaQueriesEnum.isMobile);
  const desktopNavLinks = useMemo<IHeaderNavigation[]>(
    () => [
      {
        label: t(tKeys.play),
        selected: pathname === RoutesEnum.play,
        linkData: {
          to: RoutesEnum.play,
        },
      },
      {
        label: t(tKeys.recent),
        selected: pathname === RoutesEnum.recent,
        linkData: {
          to: RoutesEnum.recent,
        },
      },
      {
        label: t(tKeys.howToPlay),
        selected: pathname === RoutesEnum.help,
        linkData: {
          to: RoutesEnum.help,
        },
      },
    ],
    [pathname, t]
  );

  const mobileNavLinks = useMemo<IHeaderNavigation[]>(
    () => desktopNavLinks.filter((x) => x.linkData.to !== RoutesEnum.help),
    [desktopNavLinks]
  );

  const navLinks = useMemo<IHeaderNavigation[]>(
    () => (isMobile ? mobileNavLinks : desktopNavLinks),
    [desktopNavLinks, isMobile, mobileNavLinks]
  );

  const sidebarNavLinks = useMemo(
    () => [
      {
        label: t(tKeys.bingo),
        icon: <TrophyIcon />,
        renderIcon: (props: any) => <TrophyIcon {...props} />,
        selected: true,
        linkData: {
          to: RoutesEnum.play,
        },
      },
    ],
    [t]
  );

  return { navLinks, sidebarNavLinks };
};
